import React from "react";
import {
  FaHeartbeat,
  FaHourglassHalf,
  FaMicroscope,
  FaPlaneDeparture,
  FaUserNurse,
  FaGlobe,
  FaNotesMedical,
  FaUsers,
} from "react-icons/fa";

const benefitData = [
  {
    icon: <FaHeartbeat />,
    title: "Cost-Conscious Patients Seeking Quality Care",
    description:
      "Individuals facing high medical costs in their home country who need affordable access to world-class healthcare without compromising.",
  },
  {
    icon: <FaHourglassHalf />,
    title: "Patients Facing Long Wait Times",
    description:
      "Individuals experiencing extended waiting periods for essential medical procedures in their home healthcare systems.",
  },
  {
    icon: <FaMicroscope />,
    title: "Patients Seeking Advanced Treatments",
    description:
      "Individuals requiring specialized procedures, cutting-edge technologies, or experimental treatments not available locally.",
  },
  {
    icon: <FaPlaneDeparture />,
    title: "Medical Travelers & Health Tourists",
    description:
      "Individuals who combine medical treatment with travel experiences, seeking wellness tourism and recovery in beautiful destinations.",
  },
  {
    icon: <FaUserNurse />,
    title: "Cosmetic & Elective Surgery Patients",
    description:
      "Individuals seeking aesthetic enhancements, cosmetic procedures, or elective surgeries at premium facilities worldwide.",
  },
  {
    icon: <FaGlobe />,
    title: "Expatriates & International Professionals",
    description:
      "Global professionals, digital nomads, and expatriates living abroad who need flexible healthcare options.",
  },
  {
    icon: <FaNotesMedical />,
    title: "Patients with Complex Medical Conditions",
    description:
      "Individuals with complicated health issues requiring multidisciplinary care and specialized medical teams.",
  },
  {
    icon: <FaUsers />,
    title: "Families Seeking Comprehensive Care",
    description:
      "Families needing coordinated medical services for multiple family members or specialized pediatric care.",
  },
  {
    icon: <FaUserNurse />,
    title: "Cosmetic & Elective Surgery Patients",
    description:
      "Individuals seeking aesthetic enhancements, cosmetic procedures, or elective surgeries at premium facilities worldwide.",
  },
];

const MedicalTourismBeneficiaries = () => {
  return (
    <>
      <h3 className="">
        Who Benefits from Our Medical Tourism Journey?
      </h3>
      <div className="py-5 bg-light">
        <div className="container text-center">
          <div className="row g-4">
            {benefitData.map((item, index) => (
              <div className="col-12 col-sm-6 col-lg-4" key={index}>
                <div className="bg-white shadow-sm h-100 p-4 rounded-4 text-start">
                  <div className="medical-thumb ">
                    <img
                      src="assets/imgs/banner/banner.jpg"
                      alt="bg"
                      className="thumb-img "
                    />
                    {/* <span className="medical-step">{item.step}</span>  */}
                  </div>
                  <div
                    className="mb-3 d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "48px",
                      height: "48px",
                      fontSize: "20px",
                      background: "#f2f7fd",
                      color: "blue",
                      marginTop: "5px"
                    }}
                  >
                    {item.icon}
                  </div>
                  <h6 className="fw-semibold mb-1">{item.title}</h6>
                  <p className="text-muted small mb-0">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MedicalTourismBeneficiaries;
